import { type FrontendRoutes, generateFrontendRoutes } from '@cosuno/routes';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useCurrentUser } from './useCurrentUser';

export const useUserRoutes = (props?: { withoutWorkspace: boolean }): FrontendRoutes => {
  const { workspaceId } = useParams<{ workspaceId?: string }>();
  const user = useCurrentUser();

  return useMemo(
    () =>
      generateFrontendRoutes({
        workspaceId: workspaceId || user?.workspaces.find(({ isCurrent }) => isCurrent)?.id,
        withoutWorkspace: props?.withoutWorkspace,
      }),
    [workspaceId, user, props?.withoutWorkspace],
  );
};
